import { Component, Input, OnInit, EventEmitter, Output } from "@angular/core";
import { Observable, BehaviorSubject, ReplaySubject, combineLatest } from "rxjs";
import { map } from "rxjs/operators";

import { fuzzy } from "../../shared/utils/search";
import { CallEvent } from "../../shared/types";

@Component({
	selector: "call-event-overview",
	templateUrl: "call-event-overview.component.html",
	styleUrls: ["call-event-overview.component.scss"],
	standalone: false,
})
export class CallEventOverviewComponent implements OnInit {
	private readonly callEventsSource$ = new ReplaySubject<CallEvent[]>();
	// @ts-expect-error TS2564
	callEvents$: Observable<CallEvent[]>;
	search$ = new BehaviorSubject<string>("");

	@Input() set callEvents(value: CallEvent[]) {
		this.callEventsSource$.next(value);
	}
	@Output() details = new EventEmitter<CallEvent>();

	ngOnInit() {
		this.callEvents$ = combineLatest(
			this.search$.pipe(map((term) => term.trim())),
			this.callEventsSource$,
			(term: string, callEvents: CallEvent[]) => ({ term, callEvents }),
		).pipe(
			map(({ term, callEvents }) => {
				if (!callEvents) {
					return callEvents;
				}

				return fuzzy(callEvents, term, "location");
			}),
		);
	}
}
